import { toast } from "react-toastify";
import React, { useCallback, useRef, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
// import "./MyPreferences.css";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Componets/Header/Header";
import Footer from "../../Componets/Footer/Footer";
import { FaCheckCircle } from "react-icons/fa";
import { useEffect } from "react";
import axios from "axios";
import {
  BASE_URL,
  PREFERENCES_DETAILS,
  PREFERENCES_UPDATE_DETAILS,
  PROFILE_DETAILS,
  access_token,
  auth_token,
  sessionID,
} from "../../services/config";
import "react-toastify/dist/ReactToastify.css";

const MyPreferences = () => {
  const effectRan = useRef(false)

  const regionsData = useSelector(state => state.region.regionsData)
  const sessionID = localStorage.getItem("session_id") ? localStorage.getItem("session_id") : ""
  const navigate = useNavigate()
  const [isPreferenceChanged, setIsPreferenceChanged] = useState(false);
  const PREFERENCES_UPDATE_DETAILS = `${BASE_URL}users/${sessionID}/playlists/favourite/list.gzip?region=${regionsData?.country_code2}`;
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [selectedShows, setSelectedShows] = useState([]);
  const [selectedSerials, setSelectedSerials] = useState([]);
  const [allSelectedItems, setAllSelectedItems] = useState([]);
  const [preferencesPageData, setPreferencesPageData] = useState({});
  const [catalogListData, setCatalogListData] = useState([]);
  const [loading, setLoading] = useState(false)

  const PreferenceButton = ({ name, selectedItems, handleButtonClick }) => {
    return (
      <Col lg={3} md={4} sm={6} xs={12}>
        <div className="come">
          <button
            onClick={(event) => handleButtonClick(name.toLowerCase(), event)}
            className={`come-button ${
              selectedItems.includes(name.toLowerCase()) ? "active" : ""
            } pr-list`}
          >
            {name}
            {selectedItems.includes(name.toLowerCase()) && (
              <FaCheckCircle style={{ fontSize: "20px" }} />
            )}
          </button>
        </div>
      </Col>
    );
  };

    

  const getListApiUrl = `${BASE_URL}users/${sessionID}/playlists/favourite/listitems.gzip?auth_token=${auth_token}&access_token=${access_token}&region=${regionsData?.country_code2}`;
  const fetchListDetails = async () => {
    try {
      setLoading(true)
      const response = await axios.get(getListApiUrl);
      if (response?.status === 200) {
        const fetchedShows =
          response.data?.data.items
            .filter((item) => item.catalog_name === "Shows")
            .map((item) => item.title.toLowerCase())
            .flat() || [];
        setSelectedShows(fetchedShows);

        const fetchedSerials =
          response.data?.data.items
            .filter((item) => item.catalog_name === "Serials")
            .map((item) => item.title.toLowerCase())
            .flat() || [];
        // console.log(fetchedSerials, "fetchedSerials");
        setSelectedSerials(fetchedSerials);
        setLoading(false)
      }
    } catch (error) {
      console.error("Error fetching data:", error?.message);
      // toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchListDetails();
  // }, []);

  const fetchProfileDetails = async () => {
    try {
      // setLoading(true);
      const nextApiUrl = PROFILE_DETAILS;
      const response = await axios.get(nextApiUrl);

      if (response?.status === 200) {
        const genreDetails = response.data.data.genres;
        setSelectedButtons(genreDetails);
      }
    } catch (error) {
      console.error("Error fetching data:", error?.message);
      // toast.error(error?.message);
    } finally {
      // setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchProfileDetails();
  // }, []);

  const fetchPreferencesDetails = async () => {
    try {
      const response = await axios.get(PREFERENCES_DETAILS);
      const responsedata = response?.data?.data;
      if (response?.status === 200) {
        setPreferencesPageData(responsedata);
        setCatalogListData(responsedata?.catalog_list_items || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error?.message);
      toast.error(error?.message);
    }
  };

  // useEffect(() => {
  //   fetchProfileDetails();
  //   fetchPreferencesDetails();
  //   fetchListDetails()
  // },[]);

  useEffect(() => {
    if (effectRan.current === false) {
      fetchProfileDetails();
      fetchPreferencesDetails();
      fetchListDetails();
      return () => {
        effectRan.current = true
      }
    }
  }, []);
  

  const genres =
    preferencesPageData?.catalog_list_items
      ?.filter(
        (item) =>
          item.display_title === "Genres" &&
        (item?.web_layout_type ?? item?.layout_type) === "preference" &&
        item.layout_structure === "horizontal" &&
          item.catalog_list_items
      )
      .map((item) =>
        item.catalog_list_items.map((initem) => initem.display_title)
      )
      .flat() || [];

  const shows =
    preferencesPageData?.catalog_list_items
      ?.filter(
        (item) =>
          item.display_title === "Popular Shows" &&
          (item?.web_layout_type ?? item?.layout_type) === "preference" &&
          item.layout_structure === "horizontal" &&
          item.catalog_list_items
      )
      .map((item) => item.catalog_list_items.map((initem) => initem.title))
      .flat() || [];

  const showsDataForPreferences =
    preferencesPageData?.catalog_list_items
      ?.filter(
        (item) =>
          item.display_title === "Popular Shows" &&
          (item?.web_layout_type ?? item?.layout_type) === "preference" &&
          item.layout_structure === "horizontal" &&
          item.catalog_list_items
      )
      .map((item) =>
        item.catalog_list_items.map((item) => ({
          title: item.title.toLowerCase(),
          content_id: item.content_id,
          catalog_id: item.catalog_id,
          delete_existing_items: false,
          delete_from_lists: ["preferences"],
        }))
      )
      .flat() || [];

  const serials =
    preferencesPageData?.catalog_list_items
      ?.filter(
        (item) =>
          item.display_title === "Popular Serials" &&
          (item?.web_layout_type ?? item?.layout_type) === "preference" &&
          item.layout_structure === "horizontal" &&
          item.catalog_list_items
      )
      .map((item) => item.catalog_list_items.map((initem) => initem.title))
      .flat() || [];

  const serialsDataForPreferences =
    preferencesPageData?.catalog_list_items
      ?.filter(
        (item) =>
          item.display_title === "Popular Serials" &&
          (item?.web_layout_type ?? item?.layout_type) === "preference" &&
          item.layout_structure === "horizontal" &&
          item.catalog_list_items
      )
      .map((item) =>
        item.catalog_list_items.map((item) => ({
          title: item.title.toLowerCase(),
          content_id: item.content_id,
          catalog_id: item.catalog_id,
          delete_existing_items: false,
          delete_from_lists: ["preferences"],
        }))
      )
      .flat() || [];

  const showsSerialsDataforPreferences = [
    ...showsDataForPreferences,
    ...serialsDataForPreferences,
  ];

  const handleButtonClick = useCallback((buttonName, setSelected, event) => {

    if (event) {
      event.preventDefault();
    }
    setSelected((prevSelected) => {
      if (prevSelected.includes(buttonName)) {
        // Deselecting a button, so check if any button is still selected
        const newSelected = prevSelected.filter((name) => name !== buttonName);
        //setIsPreferenceChanged(newSelected.length > 0);
        return newSelected;
      } else {
        // Selecting a button
       
        return [...prevSelected, buttonName];
      }
    });
    setIsPreferenceChanged(true);
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // if (!isPreferenceChanged || selectedButtons.length === 0) {
    //   return; // Return early if no button is selected
    // }

    const genresSelected = [...selectedButtons];
    const allSelected = [...selectedShows, ...selectedSerials];
    setAllSelectedItems(allSelected);

    if(allSelected.length == 0 && genresSelected.length == 0){
      toast.error("Please select atleat one Preference");
    }else{

      const updatedShowsSerialsPreferencesData = [];
      for (let i = 0; i < allSelected.length; i++) {
      let obj = showsSerialsDataforPreferences.find(
        (item) => item.title === allSelected[i]
      );
      delete obj.title;
      updatedShowsSerialsPreferencesData.push(obj);
      }

      const genreUpdate = async () => {
      try {
        const genreUpdateUrl = `${BASE_URL}users/${sessionID}/account.gzip?${regionsData?.country_code2}`;
        const response = await axios.post(genreUpdateUrl, {
          auth_token,
          access_token,
          user: {
            genres: genresSelected,
          },
        });

        if (response.status === 200) {
          window.location.href='/home'
        }
      } catch (error) {
        console.error("Error updating preferences:", error?.message);
        if (error?.response?.status === 422) {
          toast.error(error?.response?.data?.error?.message);
        }
      }
      };

      const showsSerialsUpdate = async () => {
      try {
        const response = await axios.post(PREFERENCES_UPDATE_DETAILS, {
          auth_token,
          access_token,
          delete_existing_items: false,
          delete_from_lists: ["preferences"],
          listitems: updatedShowsSerialsPreferencesData,
        });

        if (response.status === 200) {
          toast.success("Preferences updated successfully");
          navigate('/home')
          // console.log("Preferences updated successfully:", response.data.data.items);
        }
      } catch (error) {
        console.error("Error updating preferences:", error?.message);
        if (error?.response?.status === 422) {
          toast.error(error?.response?.data?.error?.message);
        }
      }
      };

      genreUpdate();
      showsSerialsUpdate();
    }
  };


  // console.log()


  return (
    <>
      {/* <Header /> */}
      <div className="main background-layer">
        <Container fluid className="pading-left-right-class preference">
        <h6 className='heading-style mb-3'>My Preference</h6>
          <div className="my-pre-main">
            <div className="my-pre-main-contant">
              <form>
                {["Genres", "Popular Shows", "Popular Serials"].map(
                  (section, index) => {
                    // console.log("section", section)
                    return (
                      <div key={index} className="genre-main">
                        <h6>{section}</h6>
                        <div className="genre-main-content">
                          <Row>
                            {loading ? <div className="text-center"><Spinner /></div> : section === "Genres" &&
                              genres.map((genre) => {
                                // console.log("genre", genre)
                                return (
                                  <PreferenceButton
                                    key={genre}
                                    name={genre}
                                    selectedItems={selectedButtons}
                                    handleButtonClick={(name, event) =>
                                      handleButtonClick(
                                        name,
                                        setSelectedButtons,
                                        event
                                      )
                                    }
                                  />
                                );
                              })}

                            {section === "Popular Shows" &&
                              shows.map((show) => (
                                <PreferenceButton
                                  key={show}
                                  name={show}
                                  selectedItems={selectedShows}
                                  handleButtonClick={(name, event) =>
                                    handleButtonClick(
                                      name,
                                      setSelectedShows,
                                      event
                                    )
                                  }
                                />
                              ))}

                            {section === "Popular Serials" &&
                              serials.map((serial) => (
                                <PreferenceButton
                                  key={serial}
                                  name={serial}
                                  selectedItems={selectedSerials}
                                  handleButtonClick={(name, event) =>
                                    handleButtonClick(
                                      name,
                                      setSelectedSerials,
                                      event
                                    )
                                  }
                                />
                              ))}
                          </Row>
                        </div>
                      </div>
                    );
                  }
                )}

                <ul className="buttons">
                  <li>
                    <div className="canle-button">
                      <Link to="/home">Cancel</Link>
                    </div>
                  </li>
                  <li>
                    <div>
                      <button
                        className="pdone-button"
                        disabled={!isPreferenceChanged}
                        onClick={handleFormSubmit}
                      >
                        Done
                      </button>
                    </div>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </Container>
        <Footer />
      </div>
    </>
  );
};

export default MyPreferences;
